<template>
  <div style="background-color: #fff">
    <el-container>
      <!-- 主体内容 -->
      <el-header
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>用户密码设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button-group>
          <el-button
            type="info"
            icon="el-icon-eleme"
            @click.native="formSubmit('refForm')"
            >修改密码</el-button
          >
        </el-button-group>
      </el-header>
      <el-main>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="refForm"
          status-icon
          label-width="100px"
        >
          <el-form-item label="用户名" prop="name">
            <el-input v-model="ruleForm.name" disabled> </el-input>
          </el-form-item>
          <el-form-item label="原有密码" prop="oldpassword">
            <el-input
              v-model="ruleForm.oldpassword"
              placeholder="请输入原有密码"
              type="password"
            />
          </el-form-item>
          <el-form-item label="新设密码" prop="pass">
            <el-input
              v-model="ruleForm.pass"
              placeholder="请输入新密码"
              type="password"
            />
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              v-model="ruleForm.checkPass"
              placeholder="请输入确认密码"
              type="password"
            />
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>
    
<script>
export default {
  created() {
    this.pstApi.setWindowTitle("用户密码设置");
    // 取用户登录信息
    this.user = this.pstApi.getUserData();
    // console.log(this.user);
    if (this.user == null) {
      //登录数据为空则返回登录界面
      this.$router.push("/Login");
    } else {
      this.ruleForm.name = this.user.name;
      this.passwordVerifyPass = this.user.passwordVerifyPass;
    }
  },
  data() {
    var checkEnterPass = (rules, value, callback) => {
      if (!this.Common.checkEnterPassword(this.ruleForm.pass, value)) {
        callback(new Error("新密码与确认密码不相同"));
      } else {
        callback();
      }
    };
    var checkNewPassword = (rules, value, callback) => {
      if (!this.Common.checkPassword(value, this.user.passwordVerifyPattern)) {
        callback(new Error(this.user.passwordVerifyMessage));
      } else {
        callback();
      }
    };
    return {
      user: "",
      passwordVerifyPass: true,
      ruleForm: {
        name: "",
        oldpassword: "",
        pass: "",
        checkPass: "",
      },
      //参数校验
      rules: {
        oldpassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        pass: [
          { required: true, trigger: "blur", validator: checkNewPassword },
        ],
        checkPass: [
          {
            required: true,
            trigger: "blur",
            validator: checkEnterPass,
          },
        ],
      },
    };
  },
  methods: {
    //表单提交
    formSubmit(formName) {
      //校验
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          // console.log("error submit!!");
          this.$toast("数据校验错误");
          return false;
        } else {
          //校验通过
          let old = this.ruleForm.oldpassword;
          let pass = this.ruleForm.pass;
          this.userApi
            .updatePassword(old, pass)
            .then((res) => {
              this.$toast("密码修改成功");
              //清除服务器token缓存
              this.userApi
                .logout()
                .then(() => {
                  //this.$toast("登出成功");
                  console.log("logout");
                  window.sessionStorage.removeItem("UserData");
                  window.sessionStorage.clear();
                  this.$router.push({ name: "Home" });
                })
                .catch(() => {
                  console.log("err");
                });
            })
            .catch((err) => {
              this.$toast("密码修改错误");
            });
        }
      });
    },
  },
};
</script>
    
  <style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-input.is- .el-input__inner {
  color: #031944;
}
/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//
.img-list {
  overflow: hidden;
  width: 100%;
  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }
    // 底部
    .img-li-b--bottom {
      margin-top: 10px;
      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }
    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }
    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }
    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }
    // 悬浮可见删除 or 放大按钮
    &:hover {
      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }
    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;
    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;
  .el-button {
    flex: 1;
  }
}
</style>